import {Injectable, Injector} from '@angular/core';
import {CanShareResult, Share, ShareOptions} from '@capacitor/share';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ExportClockInReportForm} from '../../../../Models/Reports/Rrhh/export-clock-in-report-store.model';
import {ClockInReportFilters} from '../../../../Models/Reports/Rrhh/clock-in-report-filters.model';
import {ClockInReportModelService} from '../../../Models/Reports/Rrhh/clock-in-report-model.service';

@Injectable({
  providedIn: 'root'
})
export class ClockInReportApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ClockInReportModelService
  ) {
    super(injector);
  }


  /**
   * Obtener el informe de fichajes
   *
   */
  public getTimeLogsByUserReport(params: ClockInReportFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('reports/hhrr/timelogs-by-user', params, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Enviar el informe fichajes por email
   *
   */
  public sendClockInReportByEmail(params: ExportClockInReportForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('reports/hhrr/timelogs-by-user/email', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Compartir el informe fichajes
   *
   */
  async shareClockInReport(params: { url: string, form: ExportClockInReportForm }) {
    const canShare: CanShareResult = await Share.canShare();
    const composedUrl: string = this.composeReportUrl(params);

    if (!canShare.value) {
      const clipboard: Clipboard = new Clipboard();
      await clipboard.writeText(composedUrl);

      this.toastCtrl.showInfoToast(this.translate.instant('COMMON.LINK_COPIED'));
      return;
    }

    const shareOptions: ShareOptions = {
      title: this.translate.instant('RRHH.CLOCK_IN.REPORT_TITLE'),
      text: this.translate.instant('RRHH.CLOCK_IN.REPORT_GENERATED'),
      url: composedUrl,
      dialogTitle: this.translate.instant('RRHH.CLOCK_IN.SHARE_REPORT_TITLE'),
    };

    await Share.share(shareOptions);
  }


  /**
   * Compone la URL del informe con los parámetros necesarios
   *
   */
  private composeReportUrl(params: { url: string, form: ExportClockInReportForm }): string {
    let url: string = `${params.url}&report_type=${params.form.report_type}`;
    params.form.user_ids.forEach((userId) => url += `&user_ids[]=${encodeURIComponent(userId)}`);

    return url;
  }

}
